import AppRoutes from "../src/routes/AppRoutes"
function App() {
  return (
    <AppRoutes />
  );
}

export default App;
